import React from 'react'
import ListaPreciosTab from './ListaPreciosTab'
import PreciosStyles from './PreciosStyles'

// Única página suelta del módulo con ruta propia (routes/index.js → PRECIOS_LISTA). El resto vive como
// pestaña dentro de PreciosContainer.

const Wrap = ({ titulo, children }) => (
  <div className="precios-scope" style={{ padding: '18px 24px' }}>
    <PreciosStyles />
    {/* Título simple: el banner grande se quitó, ocupaba mucho y no aportaba */}
    {titulo && (
      <h2 style={{ fontSize: 17, fontWeight: 700, color: '#0f2439', margin: '0 0 14px' }}>{titulo}</h2>
    )}
    {children}
  </div>
)

export const PreciosListaPage = () => (
  <Wrap titulo="Lista de precios a socios">
    <ListaPreciosTab />
  </Wrap>
)
